export const IMGPROXY_BASE_URL =
  "https://imgproxy-source-resizer-jjqptnly6q-ew.a.run.app";

export const replaceChooseImageUrl = (url: string) => {
  if (
    url.includes("https://storage.googleapis.com/images.appchoose.co/") ||
    url.includes("https://storage.googleapis.com/images.appchoose.io/")
  ) {
    return url.replace(
      "https://storage.googleapis.com/",
      "https://images.choose.app/insecure/resize:fill:264:264/plain/gs://",
    );
  }
  return url;
};

export const transformImageUrl = (
  url: string,
  transforms?: {
    resize?: {
      width: number;
      height: number;
    };
  },
  format: "avif" | "jpg" = "jpg",
) => {
  if (!url) return url;
  const encodedUrl = encodeURIComponent(url);

  const resizeFragment = transforms?.resize
    ? `resize:fill:${transforms.resize.width}:${transforms.resize.height}/`
    : "";

  return `${IMGPROXY_BASE_URL}/unsafe/${resizeFragment}format:${format}/plain/${encodedUrl}`;
};
